import { ApplicationRef, enableProdMode, NgZone } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).then(appRef => {
  const zone = appRef.injector.get(NgZone);
  const app = appRef.injector.get(ApplicationRef);

  const originalThen = Promise.prototype.then;

  Promise.prototype.then = function (onfulfilled?: any, onrejected?: any) {
    return originalThen.call(
      this,
      (value: any) => zone.run(() => {
        const result = onfulfilled?.(value);
        app.tick();
        return result;
      }),
      (reason: any) => zone.run(() => onrejected?.(reason))
    );
  };
});
